// import React, { useEffect, useState } from "react";
// import { Loader2, Trash2 } from "lucide-react";
// import { useAPI } from "../Context/MyContext";
// import toast from "react-hot-toast";

// const ContactSelector = ({ selectedContacts, setSelectedContacts }) => {
//   const { getAttributes, getContacts } = useAPI();

//   const [attributes, setAttributes] = useState([]);
//   const [filters, setFilters] = useState([{ attribute: "", value: "" }]);
//   const [loading, setLoading] = useState(false);
//   const [selectedCount, setSelectedCount] = useState(0);

//   // Load attributes and initial contacts
//   useEffect(() => {
//     (async () => {
//       try {
//         const res = await getAttributes();
//         const raw = res?.attributes || [];
//         const normalized = raw.map((a) =>
//           typeof a === "string" ? a : a.key ?? JSON.stringify(a)
//         );
//         setAttributes(normalized);
        
//         // Load all contacts initially
//         fetchAllContacts();
//       } catch (err) {
//         console.error("getAttributes failed:", err);
//         toast.error("Failed to load attributes");
//       }
//     })();
//   }, [getAttributes]);

//   // Fetch all contacts if no filters
//   const fetchAllContacts = async () => {
//     setLoading(true);
//     try {
//       const res = await getContacts({ page: 1, limit: 1000 });
//       // const res = await getContacts();
//       const allContacts = res.data || [];

//       const broadcastableContacts = allContacts.filter((contact) => {
//         const allow = contact.allowBroadcast;
//         return typeof allow === "string"
//           ? allow.toLowerCase() === "true"
//           : Boolean(allow);
//       });

//       setSelectedCount(broadcastableContacts.length);
//       setSelectedContacts(broadcastableContacts);
//     } catch (err) {
//       console.error("fetchAllContacts error:", err);
//       toast.error("Failed to fetch contacts");
//       setSelectedCount(0);
//       setSelectedContacts([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Apply filters function - only called when user clicks Apply
//   const applyFilters = async () => {
//     const validFilters = filters.filter(
//       (f) => f.attribute && f.value.trim().length > 0
//     );

//     if (validFilters.length === 0) {
//       fetchAllContacts();
//       return;
//     }

//     setLoading(true);
//     try {
//       // let params = { page: 1, limit: 500 };
//       let params = { page: 1, limit: 500 };
      
//       validFilters.forEach((f) => {
//         if (f.attribute && f.value.trim()) {
//           params[f.attribute] = f.value.trim();
//         }
//       });
//       const res = await getContacts(params);
//       const contacts = res.data || [];

//       const broadcastableContacts = contacts.filter((contact) => {
//         const allow = contact.allowBroadcast;
//         return typeof allow === "string"
//           ? allow.toLowerCase() === "true"
//           : Boolean(allow);
//       });

//       setSelectedCount(broadcastableContacts.length);
//       setSelectedContacts(broadcastableContacts);
//     } catch (err) {
//       console.error("applyFilters error:", err);
//       toast.error("Failed to fetch contacts");
//       setSelectedCount(0);
//       setSelectedContacts([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Clear all filters
//   const clearFilters = () => {
//     setFilters([{ attribute: "", value: "" }]);
//     fetchAllContacts();
//   };

//   // Update a filter row
//   const updateFilter = (index, key, value) => {
//     const updated = [...filters];
//     updated[index][key] = value;
//     setFilters(updated);
//   };

//   // Remove a filter row
//   const removeFilter = (index) => {
//     const updated = filters.filter((_, i) => i !== index);
//     setFilters(updated.length > 0 ? updated : [{ attribute: "", value: "" }]);
//   };

//   // Add new filter row
//   const addFilter = () => {
//     setFilters([...filters, { attribute: "", value: "" }]);
//   };

//   // Check if there are active filters
//   const hasActiveFilters = filters.some(f => f.attribute && f.value.trim());

//   return (
//     <div className="p-4 bg-white border rounded-xl shadow-sm">
//       <h2 className="text-lg font-semibold text-green-700 mb-3">
//         Select Contacts
//       </h2>

//       {/* Multiple Filter Rows */}
//       <div className="space-y-2">
//         {filters.map((f, i) => (
//           <div key={i} className="flex gap-2">
//             {/* Attribute */}
//             <select
//               value={f.attribute}
//               onChange={(e) => updateFilter(i, "attribute", e.target.value)}
//               className="w-1/3 px-3 py-2 border rounded text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
//             >
//               <option value="">Select Attribute</option>
//               {attributes.map((attr) => (
//                 <option key={attr} value={attr}>
//                   {attr}
//                 </option>
//               ))}
//             </select>

//             {/* Value */}
//             <input
//               type="text"
//               placeholder={
//                 f.attribute ? `Enter ${f.attribute} value` : "Enter value"
//               }
//               value={f.value}
//               onChange={(e) => updateFilter(i, "value", e.target.value)}
//               className="w-1/3 px-3 py-2 border rounded text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
//             />

//             {/* Remove */}
//             <button
//               onClick={() => removeFilter(i)}
//               className="ml-2 flex items-center justify-center w-7 h-7 bg-red-400 hover:bg-red-500 rounded-full"
//               disabled={filters.length === 1}
//             >
//               <Trash2 className="w-4 h-4 text-white" />
//             </button>
//           </div>
//         ))}

//         {/* Action Buttons */}
//         <div className="flex gap-2 mt-3">
//           <button
//             onClick={addFilter}
//             className="px-3 py-1 bg-green-500 text-white rounded hover:bg-green-600"
//           >
//             + Add Filter
//           </button>
          
//           <button
//             onClick={applyFilters}
//             className="px-4 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
//             disabled={loading}
//           >
//             {loading ? "Applying..." : "Apply Filters"}
//           </button>

//           {hasActiveFilters && (
//             <button
//               onClick={clearFilters}
//               className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600"
//             >
//               Clear All
//             </button>
//           )}
//         </div>
//       </div>

//       {/* Results */}
//       <div className="mt-4">
//         {loading ? (
//           <div className="flex items-center gap-2 text-sm text-gray-600">
//             <Loader2 className="animate-spin w-4 h-4" />
//             Searching contacts...
//           </div>
//         ) : selectedCount > 0 ? (
//           <div className="text-sm text-green-700 font-medium">
//             Found {selectedCount.toLocaleString()} contacts ready for
//             broadcasting
//           </div>
//         ) : (
//           <div className="text-sm text-gray-500">
//             No broadcastable contacts found
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ContactSelector;



import React, { useEffect, useState } from "react";
import { Loader2, Trash2 } from "lucide-react";
import { useAPI } from "../Context/MyContext";
import toast from "react-hot-toast";

const ContactSelector = ({ selectedContacts, setSelectedContacts }) => {
  const { getAttributes, getContacts, getFullContacts } = useAPI();

  const [attributes, setAttributes] = useState([]);
  const [filters, setFilters] = useState([{ attribute: "", value: "" }]);
  const [loading, setLoading] = useState(false);
  const [selectedCount, setSelectedCount] = useState(0);

  // Load attributes and initial contacts
  useEffect(() => {
    (async () => {
      try {
        const res = await getAttributes();
        const raw = res?.attributes || [];
        const normalized = raw.map((a) =>
          typeof a === "string" ? a : a.key ?? JSON.stringify(a)
        );
        setAttributes(normalized);
        
        // Load all contacts initially
        fetchAllContacts();
      } catch (err) {
        console.error("getAttributes failed:", err);
        toast.error("Failed to load attributes");
      }
    })();
  }, [getAttributes]);

  // Fetch all contacts if no filters
  // const fetchAllContacts = async () => {
  //   setLoading(true);
  //   try {
  //     const res = await getContacts({ page: 1, limit: 1000 });
  //     // const res = await getContacts();
  //     const allContacts = res.data || [];

  //     const broadcastableContacts = allContacts.filter((contact) => {
  //       const allow = contact.allowBroadcast;
  //       return typeof allow === "string"
  //         ? allow.toLowerCase() === "true"
  //         : Boolean(allow);
  //     });

  //     setSelectedCount(broadcastableContacts.length);
  //     setSelectedContacts(broadcastableContacts);
  //   } catch (err) {
  //     console.error("fetchAllContacts error:", err);
  //     toast.error("Failed to fetch contacts");
  //     setSelectedCount(0);
  //     setSelectedContacts([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

// Fetch all contacts initially
const fetchAllContacts = async () => {
  setLoading(true);
  try {
    // const res = await getContacts(); // <-- no page or limit
    const res = await getFullContacts(); // <-- no page or limit
    const allContacts = res.data || [];

    const broadcastableContacts = allContacts.filter((contact) => {
      const allow = contact.allowBroadcast;
      return typeof allow === "string"
        ? allow.toLowerCase() === "true"
        : Boolean(allow);
    });

    setSelectedCount(broadcastableContacts.length);
    setSelectedContacts(broadcastableContacts);
  } catch (err) {
    console.error("fetchAllContacts error:", err);
    toast.error("Failed to fetch contacts");
    setSelectedCount(0);
    setSelectedContacts([]);
  } finally {
    setLoading(false);
  }
};

// Apply filters function
const applyFilters = async () => {
  const validFilters = filters.filter(
    (f) => f.attribute && f.value.trim().length > 0
  );

  if (validFilters.length === 0) {
    fetchAllContacts();
    return;
  }

  setLoading(true);
  try {
    const params = {};
    validFilters.forEach((f) => {
      if (f.attribute && f.value.trim()) {
        params[f.attribute] = f.value.trim();
      }
    });

    // const res = await getContacts(params); // <-- no page/limit
    const res = await getFullContacts(params); // <-- no page/limit
    const contacts = res.data || [];

    const broadcastableContacts = contacts.filter((contact) => {
      const allow = contact.allowBroadcast;
      return typeof allow === "string"
        ? allow.toLowerCase() === "true"
        : Boolean(allow);
    });

    setSelectedCount(broadcastableContacts.length);
    setSelectedContacts(broadcastableContacts);
  } catch (err) {
    console.error("applyFilters error:", err);
    toast.error("Failed to fetch contacts");
    setSelectedCount(0);
    setSelectedContacts([]);
  } finally {
    setLoading(false);
  }
};


  // Apply filters function - only called when user clicks Apply
  // const applyFilters = async () => {
  //   const validFilters = filters.filter(
  //     (f) => f.attribute && f.value.trim().length > 0
  //   );

  //   if (validFilters.length === 0) {
  //     fetchAllContacts();
  //     return;
  //   }

  //   setLoading(true);
  //   try {
  //     // let params = { page: 1, limit: 500 };
  //     let params = { page: 1, limit: 500 };
      
  //     validFilters.forEach((f) => {
  //       if (f.attribute && f.value.trim()) {
  //         params[f.attribute] = f.value.trim();
  //       }
  //     });
  //     const res = await getContacts(params);
  //     const contacts = res.data || [];

  //     const broadcastableContacts = contacts.filter((contact) => {
  //       const allow = contact.allowBroadcast;
  //       return typeof allow === "string"
  //         ? allow.toLowerCase() === "true"
  //         : Boolean(allow);
  //     });

  //     setSelectedCount(broadcastableContacts.length);
  //     setSelectedContacts(broadcastableContacts);
  //   } catch (err) {
  //     console.error("applyFilters error:", err);
  //     toast.error("Failed to fetch contacts");
  //     setSelectedCount(0);
  //     setSelectedContacts([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // Clear all filters
  const clearFilters = () => {
    setFilters([{ attribute: "", value: "" }]);
    fetchAllContacts();
  };

  // Update a filter row
  const updateFilter = (index, key, value) => {
    const updated = [...filters];
    updated[index][key] = value;
    setFilters(updated);
  };

  // Remove a filter row
  const removeFilter = (index) => {
    const updated = filters.filter((_, i) => i !== index);
    setFilters(updated.length > 0 ? updated : [{ attribute: "", value: "" }]);
  };

  // Add new filter row
  const addFilter = () => {
    setFilters([...filters, { attribute: "", value: "" }]);
  };

  // Check if there are active filters
  const hasActiveFilters = filters.some(f => f.attribute && f.value.trim());

  return (
    <div className="p-4 bg-white border rounded-xl shadow-sm">
      <h2 className="text-lg font-semibold text-green-700 mb-3">
        Select Contacts
      </h2>

      {/* Multiple Filter Rows */}
      <div className="space-y-2">
        {filters.map((f, i) => (
          <div key={i} className="flex gap-2">
            {/* Attribute */}
            <select
              value={f.attribute}
              onChange={(e) => updateFilter(i, "attribute", e.target.value)}
              className="w-1/3 px-3 py-2 border rounded text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
            >
              <option value="">Select Attribute</option>
              {attributes.map((attr) => (
                <option key={attr} value={attr}>
                  {attr}
                </option>
              ))}
            </select>

            {/* Value */}
            <input
              type="text"
              placeholder={
                f.attribute ? `Enter ${f.attribute} value` : "Enter value"
              }
              value={f.value}
              onChange={(e) => updateFilter(i, "value", e.target.value)}
              className="w-1/3 px-3 py-2 border rounded text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
            />

            {/* Remove */}
            <button
              onClick={() => removeFilter(i)}
              className="ml-2 flex items-center justify-center w-7 h-7 bg-red-400 hover:bg-red-500 rounded-full"
              disabled={filters.length === 1}
            >
              <Trash2 className="w-4 h-4 text-white" />
            </button>
          </div>
        ))}

        {/* Action Buttons */}
        <div className="flex gap-2 mt-3">
          <button
            onClick={addFilter}
            className="px-3 py-1 bg-green-500 text-white rounded hover:bg-green-600"
          >
            + Add Filter
          </button>
          
          <button
            onClick={applyFilters}
            className="px-4 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
            disabled={loading}
          >
            {loading ? "Applying..." : "Apply Filters"}
          </button>

          {hasActiveFilters && (
            <button
              onClick={clearFilters}
              className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600"
            >
              Clear All
            </button>
          )}
        </div>
      </div>

      {/* Results */}
      <div className="mt-4">
        {loading ? (
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <Loader2 className="animate-spin w-4 h-4" />
            Searching contacts...
          </div>
        ) : selectedCount > 0 ? (
          <div className="text-sm text-green-700 font-medium">
            Found {selectedCount.toLocaleString()} contacts ready for
            broadcasting
          </div>
        ) : (
          <div className="text-sm text-gray-500">
            No broadcastable contacts found
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactSelector;